import React, {useEffect, useRef, useState} from 'react';
import ReactDOM from 'react-dom';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  useLocation,
} from "react-router-dom";
import {QueryClientProvider, useQuery} from 'react-query';
import { HelmetProvider } from 'react-helmet-async';
import queryClient from "./services/queryClient";
import {DefaultValue, RecoilRoot, useRecoilState, useRecoilValue} from "recoil";
import useBodyClass from './hooks/ui/useBodyClass';
import Alert from "./components/Alert";
import {ErrorBoundary} from './services/bugsnag'
import useSetupAxiosMiddleware from "./hooks/useSetupAxiosAuthMiddleware";
import useFirebaseAnalytics from "./hooks/useFirebaseAnalytics";
import useScrollToTop from "./hooks/ui/useScrollToTop";
import useFetchTheatron, {useLocale, useSuggestRegion} from "./hooks/useFetchTheatron";
import useStripSearchParameters from './hooks/useStripSearchParameters';
import i18n from './services/i18n';
import logo from "../images/logo-vl.svg";
import Space from './scenes';
import api from "./services/api";

const AppProvider = ({children}) => {
  const windowRef = useRef(window);
  useScrollToTop(windowRef.current);

  useSetupAxiosMiddleware();
  useFirebaseAnalytics();

  useStripSearchParameters();

  const {data} = useFetchTheatron();

  // show loader
  return data ? (
      <Switch>
        <Route path="/:timing" children={<Space />} />
      </Switch>
  ) : null;
}

const App = () => {
  useEffect(() => {
    api.updateToken(localStorage.getItem('access_token'))
  }, []);

  return (
    <RecoilRoot>
      <QueryClientProvider client={queryClient}>
        <Router>
          <HelmetProvider>
            <Alert />
            <AppProvider />
          </HelmetProvider>
        </Router>
      </QueryClientProvider>
    </RecoilRoot>
  )
};
const ErrorView = ({error}) => {
  return (
    <div className="bg-gray-700 text-center text-white h-screen py-8">
      <img style={{height:'1.625rem'}} className="w-auto object-fit inline-block mb-4" draggable={false} src={logo} alt="Logo" />
      <h2 className={"text-2xl mb-2"}>Something went wrong!</h2>
      <p>It looks like something has gone wrong, we have been notified of this.</p>
      <p className={"mb-4"}><a className="underline" target={"_blank"} href={"https://www.cloudtix.co/contact"}>Click here to contact us</a></p>
      <textarea className="w-96 mx-auto text-sm bg-white text-black border p-2" rows={8} value={window?.location?.href + "\n" + (error?.name || '') + "\n" + (error?.message || '')} />
      <p>Please provide the information above to us when contacting us</p>
    </div>
  )
}

ReactDOM.render(
  <React.StrictMode>
    <ErrorBoundary FallbackComponent={ErrorView}>
      <App />
    </ErrorBoundary>
  </React.StrictMode>,
  document.getElementById('root')
);


